import { render } from "./stockManage.vue?vue&type=template&id=0cbc2ed7&scoped=true"
import script from "./stockManage.vue?vue&type=script&lang=js"
export * from "./stockManage.vue?vue&type=script&lang=js"

import "./stockManage.vue?vue&type=style&index=0&id=0cbc2ed7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0cbc2ed7"

export default script